<div class="container-fluid spacer-top-navigation">
  <div class="container row--primary kryptoonboarding">
    <div class="tile">
      @if (cryptoOnboardingFacade.status$ | async; as status) {
        @if (status?.onboardingProgress !== 'ONBOARDED') {
          <h2>
            {{ 'user-self-service.krypto-wallet.onboarding.success.wallet-soon-available.thx' | transloco }}
            <div class="icon icon-29">
              <img src="/assets/img/party-icon_2022-06-21.png" alt="Wallet-Eröffnung in Bearbeitung" />
            </div>
          </h2>
          <p class="mt-4">
            {{ 'user-self-service.krypto-wallet.onboarding.success.wallet-soon-available.infotext1' | transloco }}
            <br />
            {{ 'user-self-service.krypto-wallet.onboarding.success.wallet-soon-available.infotext2' | transloco }}
          </p>
          <div class="row mt-4">
            <div class="col-12 d-flex justify-content-center align-items-center">
              <web-design-system-button [routerLink]="commonRoutes.postlogin.member_home" size="large">
                Zur Startseite
              </web-design-system-button>
            </div>
          </div>
        }
        @if (status?.onboardingProgress === 'ONBOARDED') {
          <h2>
            {{ 'user-self-service.krypto-wallet.onboarding.success.wallet-available.thx' | transloco }}
            <div class="icon icon-29">
              <img src="/assets/img/party-icon_2022-06-21.png" alt="Wallet-Eröffnung erfolgreich" />
            </div>
          </h2>
          <p class="mt-4">{{ 'user-self-service.krypto-wallet.onboarding.success.wallet-available.infotext' | transloco }}</p>
          <div class="row mt-4">
            <div class="col-12 d-flex justify-content-center align-items-center">
              <web-design-system-button [routerLink]="commonRoutes.postlogin.member_home" size="large">
                Zur Startseite
              </web-design-system-button>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
